import React, { useEffect, useState } from 'react'
import { AppBar, Button, Container, Switch, InputAdornment, Toolbar, Typography, Card, CardHeader, CardContent, IconButton, Icon, TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { isEqual, cloneDeep } from 'lodash'
import clsx from 'clsx'
import { KeyboardDatePicker, DatePicker, TimePicker, KeyboardTimePicker } from '@material-ui/pickers'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import BasicInfo from '../../../components/Cards/Facility/BasicInfo'
import Configurations from '../../../components/Cards/Facility/Configurations'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'
import moment from 'moment'
import { TIME_ZONE_ABBREVIATIONS } from '../../../utils'
import { getApartmentList, updateFacility, reloadFacilities } from '../../../actions/facilities/facilities.actions'
const cutoffs = [
  { name: 'The Day Of', number: 0 },
  { name: 'One Day Before', number: 1 },
  { name: 'Two Days Before', number: 2 }
]

const fee_types = [
  'USD ($)',
  'Percentage (%)'
]

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    paddingTop: '24px',
    paddingLeft: '25px',
    paddingRight: '20px',
    paddingBottom: '75px'
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    paddingRight: '0px !important'
  },
  grid: {

  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '400px',
    '& .MuiTextField-root': { minWidth: '100px' }
  },
  dollars: {
    '& .MuiTextField-root': { minWidth: '100px' }
  },
  row2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  fieldWrapper: {
    // '& .MuiTextField-root': { width: '100%', minWidth: '100%' }
  },
  header: {
    fontSize: 12,
    fontWeight: '800',
    letterSpacing: .75,
    marginTop: 24,
    marginBottom: 8
  },
  header2: {
    fontSize: 12,
    fontWeight: '800',
    letterSpacing: .75,
    marginTop: 24,
    marginBottom: 8
  },
  purple: {
    backgroundColor: '#F0EDFB',
    width: '400px',
    padding: 12,
    paddingTop: 16,
    paddingBottom: 16,
    borderRadius: 10
  },
  purpleText: {
    fontSize: 14,
    lineHeight: '21px',
    color: '#270050',
    padding: 0,
    margin: 0
  },
  switchRoot: {
    width: 51,
    height: 31,
    padding: 0
  },
  switchBase: {
    padding: 0,
    margin: 2,
    '&$checked': {
      transform: 'translateX(20px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#6B4AD6',
        opacity: 1
      },
      '& .far::before': {
        color: '#6B4AD6'
      }
    },
    '&$focusVisible $thumb': {
      color: '#6B4AD6'
      //border: "6px solid #fff",
    },
    '&$checked + $track': {
      backgroundColor: '#6B4AD6',
      opacity: 1
    },
    '&$focusVisible $thumb': {
      color: '#6B4AD6',
      opacity: 1
    },
    '&.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#6B4AD6',
      opacity: 1
    },
    '&.MuiSwitch-switchBase.Mui-checked .far.fa-check::before': {
      color: '#6B4AD6'
    }
  },
  thumb: {
    width: 27,
    height: 27,
    background: '#F3F3F3',
    border: '1px solid #E5E5E5',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .far': {
      color: '#A2A1A4',
      fontSize: '13px',
      lineHeight: '15px'
    }
  },
  track: {
    borderRadius: 100,
    padding: 2,
    backgroundColor: '#D0CFD2',
    opacity: 1,
    transition: theme.transitions.create(['background-color'])
  },
}))

const FacilityBasicInfo = () => {
  const classes = useStyles()
  const params = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const selectedFacility = useSelector((state) => state.specific.facilities.selected)
  const markets = useSelector(state => state.specific.markets.markets)
  const loading = useSelector((state) => state.specific.facilities.loading)
  const [current, setCurrent] = useState(null)
  const [isSaveShown, setIsSaveShown] = useState(false)
  const [startTime, setStartTime] = useState(new Date())
  const [bookingCutoffTime, setBookingCutoffTime] = useState(new Date())
  const [noShowTime, setNoShowTime] = useState(new Date())
  const [type, setType] = useState('daycare')
  const [timeZone, setTimeZone] = useState('')

  useEffect(() => {
		dispatch(reloadFacilities(false))
	}, [])


  useEffect(() => {
    if (location?.pathname?.includes('boarding')) setType('boarding')
    if (location?.pathname?.includes('compatibility')) setType('compatibility')
    if (location?.pathname?.includes('grooming')) setType('grooming')
    if (location?.pathname?.includes('daycare')) setType('daycare')
  }, [location])

  useEffect(() => {
    if (params.facilityId && selectedFacility) {

      if (selectedFacility.services[type]?.visit_start_time) {
        setStartTime(moment(selectedFacility.services[type].visit_start_time, 'HH:mm').toDate())
      }
      if (selectedFacility.services[type]?.booking_cutoff_time) {
        setBookingCutoffTime(moment(selectedFacility.services[type].booking_cutoff_time, 'HH:mm').toDate())
      }
      if (selectedFacility.services[type]?.noshow_time) {
        setNoShowTime(moment(selectedFacility.services[type].noshow_time, 'HH:mm').toDate())
      }
      let market = markets.find(m => m._id === selectedFacility.market_id)
      if (market?.time_zone) {
        let tz = TIME_ZONE_ABBREVIATIONS[market.time_zone]
        if (tz) setTimeZone(tz)
      }
      setCurrent(cloneDeep(selectedFacility))
    }
  }, [params.facilityId, selectedFacility])

  useEffect(() => {
    if (current && selectedFacility) {
      let facilityEqual = !isEqual(current, selectedFacility)

      setIsSaveShown(facilityEqual)
    }
  }, [current, selectedFacility])

  const saveSelectedFacility = () => {
    let updates = {
      ...current
    }

    delete updates.kennels
    delete updates.playgroups
    delete updates.addOnTypes
    delete updates.add_on_services
    delete updates.areas
    delete updates.capacity
    delete updates.holidays
    delete updates.inventory
    delete updates.kennel_blocks
    delete updates.kennel_types
    delete updates.playgroup_types
    delete updates.playgroup_ids
    delete updates.time_blocks

    if (noShowTime) updates.services[type].noshow_time = moment(noShowTime).format('HH:mm')
    if (bookingCutoffTime) updates.services[type].booking_cutoff_time = moment(bookingCutoffTime).format('HH:mm')
    if (startTime) updates.services[type].visit_start_time = moment(startTime).format('HH:mm')
    dispatch(updateFacility(selectedFacility._id, updates))
  }

  const clearChanges = () => {
    setCurrent(cloneDeep(selectedFacility))
  }

  const getCutoffDate = () => {
    let num = current?.services[type].booking_cutoff_date || 0
    return cutoffs.find(c => c.number === num).name
  }

  const textLengthError = type === 'grooming' ? current?.services[type]?.no_fee_text?.length > 499 : current?.services[type]?.no_fee_text?.length > 199

  return (
    <div>
      {current ? (
        <Container className={classes.root} maxWidth="auto">
          <Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
            Cancellation
          </Typography>
          <Card style={{ maxWidth: '1245px' }}>
            <CardHeader />
            <CardContent>
              <div style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                padding: 16,
                backgroundColor: '#F3F3F3',
                borderRadius: 6,
                height: 63,
                marginBottom: 16
              }}>
                <Typography
                  style={{
                    color: '#1a1a35',
                    fontSize: 16,
                    fontWeight: '600',
                    marginRight: 16
                  }}>
                  Charge cancellation fees
                </Typography>
                <Switch
                  checked={current?.services[type]?.charge_cancellation_fee ? true : false}
                  onChange={() => {
                    setCurrent({
                      ...selectedFacility,
                      services: {
                        ...selectedFacility.services,
                        [type]: {
                          ...selectedFacility.services[type],
                          charge_cancellation_fee: !current?.services[type]?.charge_cancellation_fee
                        }
                      }
                    })
                  }}
                  name="sharingKennels"
                  icon={
                    <div className={classes.thumb}>
                      <Icon className="far fa-times" />
                    </div>
                  }
                  checkedIcon={
                    <div className={classes.thumb}>
                      <Icon className="far fa-check" />
                    </div>
                  }
                  classes={{
                    root: classes.switchRoot,
                    switchBase: classes.switchBase,
                    thumb: classes.thumb,
                    track: classes.track,
                    checked: classes.checked
                  }}
                />
              </div>
              {
                current?.services[type]?.charge_cancellation_fee && <Charges facility={current} setCurrent={setCurrent} type={type} timeZone={timeZone} />
              }
              {
                !current?.services[type]?.charge_cancellation_fee && <NoCharges facility={current} setCurrent={setCurrent} type={type} />
              }
            </CardContent>
          </Card>



          {isSaveShown ? (
            <AppBar position="fixed" color="primary" className={classes.appBar}>
              <Toolbar>
                <Container maxWidth="md">
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={loading || textLengthError}
                    style={{ marginRight: '8px' }}
                    onClick={() => saveSelectedFacility()}>
                    Save Changes
                  </Button>
                  <Button variant="outlined" color="secondary" onClick={clearChanges}>
                    Cancel
                  </Button>
                </Container>
              </Toolbar>
            </AppBar>
          ) : null}
        </Container>
      ) : null}
      {loading ? <LoadingOverlay /> : null}
    </div>
  )
}

const Charges = ({ facility, setCurrent, type, timeZone, setIsSaveShown }) => {
  const classes = useStyles()

  const getFreeDate = () => {
    let num = facility?.services[type].free_period_end_date || 0
    return cutoffs.find(c => c.number === num).name
  }

  const getFinalDate = () => {
    let num = facility?.services[type].mid_period_end_date || 0
    return cutoffs.find(c => c.number === num).name
  }

  const onlyNumbers = (value) => {
    if (!value || value === '0') return value
    const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
    if (onlyNums.length) return onlyNums
    return 0
  }

  const formatNumsToDollars = (value) => {
    if (value !== undefined && value !== null) {
      return `${(value / 100).toFixed(2)}`
    }
    return ''
  }

  const map_cutoffs = {
    0: 'The Day Of',
    1: 'One Day Before',
    2: 'Two Days Before'
  }

  const getCancellationPromptText = (period) => {
    try {  
      const free_hours = moment(facility.services[type].free_period_end_time, 'HH:mm').format('h:mm a')
      const free_date_text = map_cutoffs[facility.services[type].free_period_end_date].toLowerCase()
  
      if (period === 'free') {
    
        return `By cancelling prior to ${free_hours} ${free_date_text} the appointment, you are in the ${facility.services[type].free_period_name}. Cancelling in this period will not result in a fee.`
      }

      let extra_dogs = 0
    
      if (period === 'mid') {
        let fee_one = (
          (facility.services[type].mid_period_base_fee +
            (facility.services[type].mid_period_extra_dog_fee || 0) * extra_dogs) /
          100
        ).toFixed(2)

  
        if (type === 'grooming') {
          if (facility?.services?.grooming.mid_period_fee_type?.toLowerCase().includes('percent')) {
            const percent = facility.services.grooming.mid_period_base_fee_percent
            const ourprice = 5000
            fee_one = (ourprice * (percent / 100) / 100).toFixed(2)
            
            return `By cancelling after ${free_hours} ${free_date_text} the appointment, you are in the ${facility.services[type].mid_period_name}. Cancelling in this period will result in a ${facility.services[type].mid_period_base_fee_percent}% base service fee - $XX.XX.`
          }
  
        }
  
        return `By cancelling after ${free_hours} ${free_date_text} the appointment, you are in the ${facility.services[type].mid_period_name}. Cancelling in this period will result in a $${fee_one} fee.`
      }
  
      const mid_hours = moment(facility.services[type].mid_period_end_time, 'HH:mm').format('h:mm a')
      const mid_date_text = map_cutoffs[facility.services[type].mid_period_end_date].toLowerCase()
      let full_fee = (
        (facility.services[type].final_period_base_fee +
          (facility.services[type].final_period_extra_dog_fee || 0) * extra_dogs) /
        100
      ).toFixed(2)
 
      
      if (type === 'grooming') {
        if (facility?.services?.grooming.final_period_fee_type?.toLowerCase().includes('percent')) {
          const percent = facility.services.grooming.final_period_base_fee_percent
          const ourprice = 5000
          full_fee = (ourprice * (percent / 100) / 100).toFixed(2)

          return `By cancelling after ${mid_hours} ${mid_date_text} the appointment, you are in the ${facility.services[type].final_period_name}. Cancelling in this period will result in a ${facility.services[type].final_period_base_fee_percent}% base service fee - $XX.XX.`
        }
  
      }
  
      return `By cancelling after ${mid_hours} ${mid_date_text} the appointment, you are in the ${facility.services[type].final_period_name}. Cancelling in this period will result in a $${full_fee} fee.`
    } catch (e) {
      console.log('e.', e)
  
      return ''
    }
  }
  return (
    <div>
      <Typography variant="h5" className={clsx([classes.header2])} style={{ fontSize: 16 }}>
        Free Cancellation Period
      </Typography>
      <div>
        <Typography variant="h5" className={clsx([classes.header2])}>
          Name
        </Typography>
        <div className={classes.row}>
          <TextField
            id="meal-instructions"
            variant="filled"
            label="Name"
            style={{ width: '100%' }}
            value={facility?.services[type]?.free_period_name}
            onChange={(e) => setCurrent({
              ...facility,
              services: {
                ...facility.services,
                [type]: {
                  ...facility.services[type],
                  free_period_name: e.target.value
                }
              }
            })}
          />
        </div>
      </div>
      <div>
        <Typography variant="h5" className={clsx([classes.header2])}>
          End Time
        </Typography>
        <div className={classes.row}>
          <KeyboardTimePicker
            style={{ marginRight: 16 }}
            ampm={false}
            InputAdornmentProps={{
              position: 'end',
              component: () => (
                <Typography>{timeZone}</Typography>
              )
            }}
            inputVariant="filled"
            label="End Time"
            value={facility.services[type].free_period_end_time ? moment(facility.services[type].free_period_end_time, 'HH:mm').toDate() : new Date()}
            onChange={(date) => {
              if (date) {
                setCurrent({
                  ...facility,
                  services: {
                    ...facility.services,
                    [type]: {
                      ...facility.services[type],
                      free_period_end_time: date.format('HH:mm')
                    }
                  }
                })
              }
            }}
            className={classes.datePicker}
            rightArrowIcon={
              <ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
            }
            leftArrowIcon={
              <ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
            }
            KeyboardButtonProps={{
              'aria-label': 'Start Date',
              className: classes.calendarButton
            }}
          />

          <TextField
            variant="filled"
            select
            value={
              facility?.services[type].free_period_end_date
            }
            style={{ width: '48%' }}
            label="Cutoff Day"
            onChange={(e) => {
              setCurrent({
                ...facility,
                services: {
                  ...facility.services,
                  [type]: {
                    ...facility.services[type],
                    free_period_end_date: e.target.value
                  }
                }
              })
            }
            }>
            {cutoffs.map((value) => (
              <MenuItem key={`value${value.number}`} value={value.number}>
                {value.name}
              </MenuItem>
            ))
            }
          </TextField>
        </div>
      </div>
      <div>
        <Typography variant="h5" className={classes.header}>
          PREVIEW CANCELLATION TEXT
        </Typography>
        <div className={classes.purple}>
          <Typography variant="body2" className={classes.purpleText}>
            {getCancellationPromptText('free')}
          </Typography>
        </div>
      </div>

      <Typography variant="h5" className={clsx([classes.header2])} style={{ fontSize: 16, marginTop: 48 }}>
        Cancellation Window A
      </Typography>
      <div className={classes.row2}>
        <div>
          <div>
            <Typography variant="h5" className={clsx([classes.header2])}>
              Name
            </Typography>
            <div className={classes.row}>
              <TextField
                id="meal-instructions"
                variant="filled"
                label="Name"
                style={{ minWidth: 100, width: '100%' }}
                value={facility?.services[type]?.mid_period_name}
                onChange={(e) => setCurrent({
                  ...facility,
                  services: {
                    ...facility.services,
                    [type]: {
                      ...facility.services[type],
                      mid_period_name: e.target.value
                    }
                  }
                })}
              />
            </div>
          </div>
          <div>
            <Typography variant="h5" className={clsx([classes.header2])}>
              Start Time
            </Typography>
            <div className={classes.row}>
              <KeyboardTimePicker
                style={{ marginRight: 16 }}
                ampm={false}
                InputAdornmentProps={{
                  position: 'end',
                  component: () => (
                    <Typography>{timeZone}</Typography>
                  )
                }}
                inputVariant="filled"
                label="Start Time"
                disabled
                value={facility.services[type].free_period_end_time ? moment(facility.services[type].free_period_end_time, 'HH:mm').toDate() : new Date()}
                className={classes.datePicker}
                rightArrowIcon={
                  <ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
                }
                leftArrowIcon={
                  <ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
                }
                KeyboardButtonProps={{
                  'aria-label': 'Start Date',
                  className: classes.calendarButton
                }}
              />
              <TextField
                variant="filled"
                select
                disabled
                style={{ width: '50%' }}
                value={
                  facility?.services[type].free_period_end_date
                }
              >
                {cutoffs.map((value) => (
                  <MenuItem key={`value${value.number}`} value={value.number}>
                    {value.name}
                  </MenuItem>
                ))
                }
              </TextField>
            </div>
            <Typography variant="h5" className={clsx([classes.header2])}>
              End Time
            </Typography>
            <div className={classes.row}>
              <KeyboardTimePicker
                style={{ marginRight: 16 }}
                ampm={false}
                InputAdornmentProps={{
                  position: 'end',
                  component: () => (
                    <Typography>{timeZone}</Typography>
                  )
                }}
                onChange={(date) => {
                  if (date) {
                    setCurrent({
                      ...facility,
                      services: {
                        ...facility.services,
                        [type]: {
                          ...facility.services[type],
                          mid_period_end_time: date.format('HH:mm')
                        }
                      }
                    })
                  }
                }}
                inputVariant="filled"
                label="End Time"
                value={facility.services[type].mid_period_end_time ? moment(facility.services[type].mid_period_end_time, 'HH:mm').toDate() : new Date()}
                className={classes.datePicker}
                rightArrowIcon={
                  <ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
                }
                leftArrowIcon={
                  <ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
                }
                KeyboardButtonProps={{
                  'aria-label': 'Start Date',
                  className: classes.calendarButton
                }}
              />

              <TextField
                variant="filled"
                select
                value={
                  facility?.services[type].mid_period_end_date
                }
                label="Cutoff Day"
                style={{ width: '48%' }}
                onChange={(e) => {
                  setCurrent({
                    ...facility,
                    services: {
                      ...facility.services,
                      [type]: {
                        ...facility.services[type],
                        mid_period_end_date: e.target.value
                      }
                    }
                  })
                }}
              >
                {cutoffs.map((value) => (
                  <MenuItem key={`value${value.number}`} value={value.number}>
                    {value.name}
                  </MenuItem>
                ))
                }
              </TextField>
            </div>
          </div>
          <div>
            <Typography variant="h5" className={classes.header}>
              PREVIEW CANCELLATION TEXT
            </Typography>
            <div className={classes.purple}>
              <Typography variant="body2" className={classes.purpleText}>
              {getCancellationPromptText('mid')}
              </Typography>
            </div>
          </div>
        </div>

        <div style={{ padding: 24, paddingLeft: 72, paddingTop: 0 }} className={classes.dollars}>
          <Typography variant="h5" className={clsx([classes.header2])}>
            Base Fee
          </Typography>
          <div className={classes.fieldRow}>
            {
              type === 'grooming' && (
                <TextField
                  id="fee"
                  select
                  variant="filled"
                  label="Fee Type"
                  style={{
                    width: 200,
                    minWidth: 200,
                    marginRight: 16
                  }}

                  value={facility?.services[type]?.mid_period_fee_type}
                  onChange={(e) => setCurrent({
                    ...facility,
                    services: {
                      ...facility.services,
                      [type]: {
                        ...facility.services[type],
                        mid_period_fee_type: e.target.value
                      }
                    }
                  })}
                >
                  {fee_types.map((value) => (
                    <MenuItem key={`value${value}`} value={value}>
                      {value}
                    </MenuItem>
                  ))
                  }
                </TextField>
              )
            }
            {
              type !== 'grooming' || facility?.services[type]?.mid_period_fee_type?.toLowerCase().includes('usd') ? (

                <TextField
                  id="fee"
                  variant="filled"
                  label="Base Fee"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>
                  }}
                  value={formatNumsToDollars(onlyNumbers(facility?.services[type]?.mid_period_base_fee)) || ''}
                  onChange={(e) => setCurrent({
                    ...facility,
                    services: {
                      ...facility.services,
                      [type]: {
                        ...facility.services[type],
                        mid_period_base_fee: parseInt(onlyNumbers(e.target.value))
                      }
                    }
                  })}
                />
              ) : (
                <TextField
                  id="fee"
                  variant="filled"
                  label="Percentage"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>
                  }}
                  value={onlyNumbers(facility?.services[type]?.mid_period_base_fee_percent) || ''}
                  onChange={(e) => {
                    let num = parseInt(onlyNumbers(e.target.value))
                    if (num > 100 || num < 0) return
                    setCurrent({
                      ...facility,
                      services: {
                        ...facility.services,
                        [type]: {
                          ...facility.services[type],
                          mid_period_base_fee_percent: parseInt(onlyNumbers(e.target.value))
                        }
                      }
                    })
                  }}
                />
              )
            }
          </div>
          {
            type !== 'grooming' && (
              <>
                <Typography variant="h5" className={clsx([classes.header2])}>
                  Additional Dog Fee
                </Typography>
                <TextField
                  id="fee"
                  variant="filled"
                  label="Additional Dog Fee"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>
                  }}
                  value={formatNumsToDollars(onlyNumbers(facility?.services[type]?.mid_period_extra_dog_fee))}
                  onChange={(e) => setCurrent({
                    ...facility,
                    services: {
                      ...facility.services,
                      [type]: {
                        ...facility.services[type],
                        mid_period_extra_dog_fee: parseInt(onlyNumbers(e.target.value))
                      }
                    }
                  })}
                />
              </>
            )
          }
        </div>
      </div>

      {/* final period */}
      <Typography variant="h5" className={clsx([classes.header2])} style={{ fontSize: 16, marginTop: 48 }}>
        Final Cancellation Window
      </Typography>
      <div className={classes.row2}>
        <div>
          <div>
            <Typography variant="h5" className={clsx([classes.header2])}>
              Name
            </Typography>
            <div className={classes.row}>
              <TextField
                id="meal-instructions"
                variant="filled"
                label="Name"
                style={{ width: '100%' }}
                value={facility?.services[type]?.final_period_name}
                onChange={(e) => setCurrent({
                  ...facility,
                  services: {
                    ...facility.services,
                    [type]: {
                      ...facility.services[type],
                      final_period_name: e.target.value
                    }
                  }
                })}
              />

            </div>
          </div>
          <div>
            <Typography variant="h5" className={clsx([classes.header2])}>
              Start Time
            </Typography>
            <div className={classes.row}>
              <KeyboardTimePicker
                style={{ marginRight: 16 }}
                ampm={false}
                InputAdornmentProps={{
                  position: 'end',
                  component: () => (
                    <Typography>{timeZone}</Typography>
                  )
                }}
                inputVariant="filled"
                label="Start Time"
                disabled
                value={facility.services[type].mid_period_end_time ? moment(facility.services[type].mid_period_end_time, 'HH:mm').toDate() : new Date()}
                className={classes.datePicker}
                rightArrowIcon={
                  <ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
                }
                leftArrowIcon={
                  <ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
                }
                KeyboardButtonProps={{
                  'aria-label': 'Start Date',
                  className: classes.calendarButton
                }}
              />
              <TextField
                variant="filled"
                select
                disabled
                style={{ width: '48%' }}
                value={
                  facility?.services[type].mid_period_end_date
                }
              >
                {cutoffs.map((value) => (
                  <MenuItem key={`value${value.number}`} value={value.number}>
                    {value.name}
                  </MenuItem>
                ))
                }
              </TextField>
            </div>
          </div>
          <div>
            <Typography variant="h5" className={classes.header}>
              PREVIEW CANCELLATION TEXT
            </Typography>
            <div className={classes.purple}>
              <Typography variant="body2" className={classes.purpleText}>
              {getCancellationPromptText('final')}
              </Typography>
            </div>
          </div>
        </div>
        <div style={{ padding: 24, paddingLeft: 72, paddingTop: 0 }} className={classes.dollars}>
          <Typography variant="h5" className={clsx([classes.header2])}>
            Base Fee
          </Typography>
          <div className={classes.fieldRow}>
            {
              type === 'grooming' && (
                <TextField
                  id="fee"
                  select
                  variant="filled"
                  label="Fee Type"
                  style={{
                    width: 200,
                    minWidth: 200,
                    marginRight: 16
                  }}

                  value={facility?.services[type]?.final_period_fee_type}
                  onChange={(e) => setCurrent({
                    ...facility,
                    services: {
                      ...facility.services,
                      [type]: {
                        ...facility.services[type],
                        final_period_fee_type: e.target.value
                      }
                    }
                  })}
                >
                  {fee_types.map((value) => (
                    <MenuItem key={`value${value}`} value={value}>
                      {value}
                    </MenuItem>
                  ))
                  }
                </TextField>
              )
            }
            {
              type !== 'grooming' || facility?.services[type]?.final_period_fee_type?.toLowerCase().includes('usd') ? (

                <TextField
                  id="fee"
                  variant="filled"
                  label="Base Fee"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>
                  }}
                  value={formatNumsToDollars(onlyNumbers(facility?.services[type]?.final_period_base_fee)) || ''}
                  onChange={(e) => setCurrent({
                    ...facility,
                    services: {
                      ...facility.services,
                      [type]: {
                        ...facility.services[type],
                        final_period_base_fee: parseInt(onlyNumbers(e.target.value))
                      }
                    }
                  })}
                />
              ) : (
                <TextField
                  id="fee"
                  variant="filled"
                  label="Percentage"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>
                  }}
                  value={onlyNumbers(facility?.services[type]?.final_period_base_fee_percent) || ''}
                  onChange={(e) => {
                    let num = parseInt(onlyNumbers(e.target.value))
                    if (num > 100 || num < 0) return
                    setCurrent({
                      ...facility,
                      services: {
                        ...facility.services,
                        [type]: {
                          ...facility.services[type],
                          final_period_base_fee_percent: parseInt(onlyNumbers(e.target.value))
                        }
                      }
                    })
                  }}
                />
              )
            }
          </div>

          {
            type !== 'grooming' && (
              <>
                <Typography variant="h5" className={clsx([classes.header2])}>
                  Additional Dog Fee
                </Typography>
                <TextField
                  id="fee"
                  variant="filled"
                  label="Base Fee"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>
                  }}
                  value={formatNumsToDollars(onlyNumbers(facility?.services[type]?.final_period_extra_dog_fee))}
                  onChange={(e) => setCurrent({
                    ...facility,
                    services: {
                      ...facility.services,
                      [type]: {
                        ...facility.services[type],
                        final_period_extra_dog_fee: parseInt(onlyNumbers(e.target.value))
                      }
                    }
                  })}
                />
              </>
            )
          }
        </div>
      </div>
    </div>
  )
}

const NoCharges = ({ facility, setCurrent, type }) => {
  const classes = useStyles()
  return (
    <div>
      <Typography variant="h5" className={clsx([classes.header2, classes.bigHeader])}>
        NO CANCELLATION FEE TEXT
      </Typography>
      <TextField
        id="meal-instructions"
        variant="filled"
        multiline
        label="No Cancellation Fee Text"
        style={{ width: '50%' }}
        value={facility?.services[type]?.no_fee_text}
        error={type === 'grooming' ? facility?.services[type]?.no_fee_text?.length > 499 : facility?.services[type]?.no_fee_text?.length > 199}
        helperText={type === "grooming" ? `${facility?.services[type]?.no_fee_text?.length || '0'} / 500` : `${facility?.services[type]?.no_fee_text?.length || '0'} / 200`}
        onChange={(e) => setCurrent({
          ...facility,
          services: {
            ...facility.services,
            [type]: {
              ...facility.services[type],
              no_fee_text: e.target.value
            }
          }
        })}
      />
      {
        facility?.services[type]?.no_fee_text &&
        <div>
          <Typography variant="h5" className={classes.header}>
            PREVIEW NO CANCELLATION FEES TEXT
          </Typography>
          <div className={classes.purple}>
            <Typography variant="body2" className={classes.purpleText}>
              {facility?.services[type]?.no_fee_text}
            </Typography>
          </div>
        </div>
      }
    </div>
  )
}

export default FacilityBasicInfo
